import { DOCUMENT, DestroyRef, Injectable, inject, signal } from '@angular/core';

/** Estado de red del navegador (`navigator.onLine` + eventos `online`/`offline`). */
@Injectable({ providedIn: 'root' })
export class ConnectivityService {
  private readonly online = signal(true);
  readonly isOnline = this.online.asReadonly();

  constructor() {
    const view = inject(DOCUMENT).defaultView;
    if (!view) return;

    this.online.set(view.navigator.onLine);
    const goOnline = () => this.online.set(true);
    const goOffline = () => this.online.set(false);
    view.addEventListener('online', goOnline);
    view.addEventListener('offline', goOffline);
    inject(DestroyRef).onDestroy(() => {
      view.removeEventListener('online', goOnline);
      view.removeEventListener('offline', goOffline);
    });
  }
}
